import { apiClient } from "./api-client";
import type { MyReservation, ReservationMutation } from "../types/reservation";

export function getMyReservations(): Promise<MyReservation[]> {
  return apiClient
    .get<{ data: MyReservation[] }>("/my-reservations")
    .then((response) => response.data);
}

export function reserveWish(wishId: string): Promise<ReservationMutation> {
  return apiClient
    .post<{ data: ReservationMutation }>(`/wishes/${wishId}/reserve`)
    .then((response) => response.data);
}

export function cancelReservation(reservationId: string): Promise<ReservationMutation> {
  return apiClient
    .delete<{ data: ReservationMutation }>(`/reservations/${reservationId}`)
    .then((response) => response.data);
}

export function purchaseReservation(reservationId: string): Promise<ReservationMutation> {
  return apiClient
    .patch<{ data: ReservationMutation }>(`/reservations/${reservationId}/purchase`, undefined)
    .then((response) => response.data);
}

export function restoreReservation(reservationId: string): Promise<ReservationMutation> {
  return apiClient
    .patch<{ data: ReservationMutation }>(`/reservations/${reservationId}/reserve`, undefined)
    .then((response) => response.data);
}
